import { useEffect, useRef } from 'react';
import useEnhancedEffect from '../useEnhancedEffect';
import type { UseInterval } from './types';

const useInterval: UseInterval = (callback, delay = 0) => {
  const savedCallback = useRef(callback);

  useEnhancedEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!delay && delay !== 0) {
      return;
    }

    const id = setInterval(() => savedCallback.current(), delay);

    return () => clearInterval(id);
  }, [delay]);
};

export default useInterval;
